// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 383 ? "71365615" : chunkId) + "." + {"383":"4958dee91b9f8fd6","444":"cf681f3d31bf89e0","457":"740ca4168c951d4c"}[chunkId] + ".js";
};